module.exports = __webpack_public_path__ + "static/kismet.25be337c.jpg";